<template>
  <div id="millia">
   
  <!--其他HTML结构-->
   
  <ul class="btGroup">
  <li @click="goRule('Rule')">规则</li>
  <li @click="goRule('Info')">奖励</li>
  <li @click="goRule('Intro')">介绍</li>
  </ul>
   
  <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
   
  <div class="millia intro f14 lh26" id="Rule">
  活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍活动介绍
  </div>
   
  <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
   
  <div class="millia intro f14 lh26" id="Info">
  奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励奖励
  </div>
   
  <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
   
  <div class="millia intro f14 lh26" id="Intro">
  活动介绍活动介绍活动介绍活动介绍活动介绍
  </div>
   
  <!--其他HTML结构-->
   
  </div>
  </template>
  <script>
  export default {
    name: 'index',
    data(){
      return{
   
      }
    },
    methods:{
      //锚点跳转
      goRule(event) {
        var id = "#" + event;
        document.querySelector(id).scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      },
    },
  }
  </script>
  <style scoped>
   
  </style>